import React, { useRef, useState } from "react";
import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { BsLinkedin, BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";
import { contact } from "../../data/profile";

const OPTIONS = [
  { key: "email", Icon: MdOutlineEmail, title: "Email", value: contact.email, href: `mailto:${contact.email}`, cta: "Send Email" },
  { key: "linkedin", Icon: BsLinkedin, title: "LinkedIn", value: "Burak Sağ", href: contact.linkedin, cta: "Connect" },
  { key: "whatsapp", Icon: BsWhatsapp, title: "WhatsApp", value: contact.phoneDisplay, href: contact.whatsapp, cta: "Send a Message" },
];

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error

  // EmailJS public credentials (safe to ship client-side)
  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .sendForm("service_w9p172e", "template_47m0e6s", form.current, "5ub4n8s21UQo_LOHU")
      .then(
        () => {
          setStatus("sent");
          form.current.reset();
        },
        () => setStatus("error")
      );
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          {OPTIONS.map(({ key, Icon, title, value, href, cta }) => (
            <article className="contact__option" key={key}>
              <Icon className="contact__option-icon" />
              <h4>{title}</h4>
              <h5>{value}</h5>
              <a href={href} target="_blank" rel="noopener noreferrer">
                {cta}
              </a>
            </article>
          ))}
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" rows="7" placeholder="Your Message" required></textarea>

          <button type="submit" className="btn btn-primary" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send Message"}
          </button>

          {status === "sent" && <p className="contact__status">Thanks! Your message has been sent.</p>}
          {status === "error" && (
            <p className="contact__status contact__status--error">
              Something went wrong. Please email me directly at {contact.email}.
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
